import { STORYBLOK_VERSION } from "@config/config"
import { ISbStoriesParams } from "@storyblok/react/rsc"

export const defaultSbParams: ISbStoriesParams = {
  version: STORYBLOK_VERSION,
  from_release: process.env.STORYBLOK_CONTENT_PIPELINE
}
